import { useProductListing } from '~/composables/useProductListing';

const ALLOW_TAXONOMIES = Object.freeze([
    'category',
    'metal_color',
    'gemstone',
    'material',
    'collection',
    'occasions',
    'gold_type',
    'bridal',
    'price_range',
    'recipients',
    'gift'
] as const)

type AllowedTaxonomy = typeof ALLOW_TAXONOMIES[number]


export default defineNuxtRouteMiddleware((to, from) => {
    if (!from.name) return
    const { clearProductParams } = useProductListing();

    const tax = (from.name as string).replace('-slug', '') as AllowedTaxonomy;
    if (ALLOW_TAXONOMIES.includes(tax)) {
        clearProductParams();
    }
})